import React, { useEffect } from 'react';
import { Box, Button, Grid, IconButton, Slider, TextField, Typography } from '@mui/material';
import HEADPHONES from '../../assets/images/headphones.svg'
import audioGif from "../../assets/images/audio.gif";
import play from "../../assets/images/play.svg";
import plus from "../../assets/images/plus button.svg";
import minus from "../../assets/images/minus button.svg";
import speaker from "../../assets/images/speaker.svg";
import sineFreq from "../../assets/images/sine freq.svg";
import squareFreq from "../../assets/images/square freq.svg";
import sawToothFreq from "../../assets/images/sawTooth freq.svg";
import narrowbandFreq from "../../assets/images/narrowband freq.svg";

const PhaseThreeUI = ({handleNext, handleLoudnessTest, isPlaying, frequency, setFrequency,selectedWave, handleFrequencyTest, handleFrequencyChange,increaseFreq, decreaseFreq,
    setSelectedWave, canvasRef,  startWaveAnimation,   isMobile}) => {

  
  return (
    <>
    <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', height:'20vh'}}>
  <Typography  mb={4} className='AxiformaBold' align="center" fontWeight={700} fontSize={'32px'} color={"#5E5E5E"}>
  Set the frequency and select a mode that matches your tinnitus
  </Typography>


  <Box mt={0} sx={{ width: '100%', maxWidth: '800px', border: '1px solid #DEDEDE', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2 }}>
    <Typography className='AxiformaMedium' sx={{ color: '#424242' }}>Select Mode</Typography>
  
    {['sine', 'square', 'sawtooth', 'narrowband'].map((wave) => (
      <Button key={wave} onClick={() => setSelectedWave(wave)} sx={{ width: '20%', background: selectedWave === wave ? '#FEF7F6' : '#F7F7F7', border: selectedWave === wave ? '1px solid #DE4646' : '' }}>
        <img src={wave === 'sine' ? sineFreq : wave === 'square' ? squareFreq : wave === 'sawtooth' ? sawToothFreq : narrowbandFreq} alt={wave} />
        <Typography sx={{ color: '#666666', ml: 3 }}>{wave.charAt(0).toUpperCase() + wave.slice(1)}</Typography>
      </Button>
    ))}
  </Box>

    <canvas
            ref={canvasRef}
            width={isMobile ? 600 : 700}
            height={isMobile ? 40 : 90}
            style={{
              marginBottom: "7px",
              marginTop: "30px",
        
          
            }}
          />
           <IconButton
        aria-label="play"
        onClick={() => {
          handleFrequencyTest(); 
          startWaveAnimation(); 
        
        }}
        style={{
          opacity: isPlaying ? 0.2 : 1, 
          transition: "opacity 0.3s ease", 
        }}
      >
        <img src={play} alt="Play Button" style={{ height: "8vh" }} />
      </IconButton>




<Box mt={2} sx={{display:'flex' , flexDirection:'column', width:'70%', alignItems:'center', justifyContent:'center'}}>
   
<Box
  mt={0}
  sx={{
    minWidth: '70vw', // Ensures a minimum width for the box
    height: '12vh',
    border: '1px solid #DEDEDE',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  
    overflow: 'visible', // Ensures content doesn't get clipped
  }}
>
  
<Box sx={{ width: '62vw', height: '11.7vh', borderRight: '1px solid #DEDEDE', background: '#F5F5F5', borderTopLeftRadius:'8px',borderBottomLeftRadius:'8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              
              <Box onClick={decreaseFreq} sx={{ display: 'flex', justifyContent: 'flex-start', p: 4 }}>
              <IconButton onClick={decreaseFreq}><img src={minus} alt="Minus" /></IconButton>
                
              </Box>
            
              <Box sx={{ width: '70vw', display: 'flex', alignItems: 'center', justifyContent: 'center', p:4 }}>
              <Slider
  value={frequency}
  onChange={(e, value) => setFrequency(value)}
  min={100}
  max={20000}
  step={100}
  sx={{
    width: "100%",
    mx: 2,
    color: "#d34646", // Primary slider color
    height: 8,
    "& .MuiSlider-thumb": {
      height: 24,
      width: 24,
      bgcolor: "#ffffff",
      border: "2px solid #d34646",
      "&:before": {
        position: "absolute",
        content: '""',
        border: "1px solid #D34646",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      },
      "&:hover, &.Mui-focusVisible": {
        boxShadow: "0px 0px 0px 5px rgba(211, 70, 70, 0.16)",
      },
    },
    "& .MuiSlider-rail": {
      color: "#D9D9D9",
      opacity: 1,
      height: 8,
    },
    "& .MuiSlider-track": {
      height: 8,
      border: "none",
    },
    "& .MuiSlider-mark": {
      height: 10,
      width: 2,
      backgroundColor: "#DEDEDE",
      position: "absolute",
      top: 30, // Adjust the mark's vertical alignment
    },
    "& .MuiSlider-markLabel": {
      color: "#666666",
      fontSize: "12px",
      fontWeight: "400",
      position: "absolute",
      top: 42, // Space between mark and label
      transform: "translateX(-40%)",
    },
  }}
  marks={[
    { value: 100, label: "100 Hz" },
    { value: 5000, label: "5 kHz" },
    { value: 10000, label: "10 kHz" },
    { value: 15000, label: "15 kHz" },
    { value: 20000, label: "20 kHz" },
  ]}
/>

              </Box>
            
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 4  }}>
               <IconButton onClick={increaseFreq}><img src={plus} alt="Plus" /></IconButton> 
              </Box>
            </Box>
            <Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px',
    flexWrap: 'nowrap',
    gap: '4px', // Adds space between the TextField and Hz Typography
  }}
>
  <TextField
    value={frequency}
    onChange={(e) => setFrequency(Number(e.target.value))}
    onBlur={handleFrequencyChange}
    inputProps={{
      style: {
        fontSize: '2rem', // Matches Typography h2 font size
        fontWeight: 700, // Matches Typography font weight
        color: '#424242', // Matches Typography color
        textAlign: 'center', // Centers the text
        padding: 0, // Removes extra padding
        width: `${frequency.toString().length * 20}px`, // Adjust width dynamically
      },
    }}
    sx={{
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none', // Removes default border
      },
      '& .MuiInputBase-root': {
        background: 'transparent', // Matches Typography background
      },
      '& .MuiInputBase-input': {
        textAlign: 'center',
      },
      '& .MuiInput-underline:before': {
        borderBottom: '2px solid #424242', // Adds underline
      },
      '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottom: '2px solid #424242', // Changes underline color on hover
      },
      '& .MuiInput-underline:after': {
        borderBottom: '2px solid #424242', // Changes underline color on focus
      },
    }}
    variant="standard" // Changes to underline variant
  />
  <Typography sx={{ color: '#B3B3B3', fontSize: '13px' }}>Hz</Typography>
</Box>

</Box>
           
    </Box>
   
    <Button  sx={{width:'30vw', height:'12vh',background:'#424242', radius:'8px', alignItems:'center', color:'white', marginTop:'30px'}} onClick={handleNext}>
      <Typography sx={{fontSize:'24px'}}>Confirm Selection</Typography>  
    </Button>

  </Box>
    </>
  
)}

export default PhaseThreeUI;
